//@flow
import api from './';


export function get(){
    return api('get', `/api/v1/iam/authorities`);
}